import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import Welcome from "../../components/Welcome";
import ImageText1 from "../../components/ImageText1";
import Footer from "../../components/Footer";
import videoSource from "../../assets/video/home_video_1.mp4";
import imageUrl from "../../assets/images/home/home-section1.jpg";
// import VideoText from "./VideoText";

function Home() {
  const welcomeHeading = "SAMEN OP WEG";
  const welcomeText =
    "DD-Group stelt zichzelf ten doel om opdrachtgevers en werknemers te boeien en langdurig te binden met ons grote aanbod van diensten en oplossingen op bedrijfsmatig en individueel niveau. Uw voordeel is ook ons voordeel, wij doen er alles aan om een win-win situatie te creëren. Wij gaan samen met u op weg!";
  const imageTextHeading = "Wat wij doen ";
  const imageTextText = (
    <>
      DD-Group is een kwalitatief hoogstaande speler op de Nederlandse en
      Belgische (arbeids-) markt. Wij hebben onze roots in de segmenten
      techniek, maritiem, logistiek en industrie, maar kunnen met onze
      (advies-)diensten elke sector in Nederland en België bedienen. <br />
      Wij werven en plaatsen werknemers over de landsgrenzen van Nederland en
      België heen. Hiermee bieden wij flexibiliteit aan opdrachtgevers en
      werknemers in de grensregio’s. <br />
      DD-Group biedt een grote diversiteit aan diensten op het gebied van
      Crossborder Recruitment, Sales & Finance, Inkoop & Logistiek en HR &
      Organisatieadvies. Wij onderscheiden ons in de markt door een persoonlijke
      en kwalitatief gedegen aanpak tegen concurrerende tarieven. Onze
      flexibiliteit kent geen grenzen. <br />
      DD-Group is VCA gecertificeerd en kan als aannemer (technische) projecten
      aannemen. <br />
      DD-Group heeft maatschappelijk verantwoord ondernemen hoog in het vaandel
      staan en sponsort meerdere sportverenigingen. DD-Group is hoofdsponsor van
      de UCI Dames Wielrenploeg “De Ploeg op de Root”.
    </>
  );

  // const imageTextHeading2 = "DD-GROUP";
  // const imageTextText2 = (
  //   <>
  //     Levert kwaliteit in mensen en opdrachten
  //     <br />
  //     <br />
  //     Is een organisatie gericht op het ontzorgen van de ZZP-ers en
  //     opdrachtgevers in de breedste zin van het woord.
  //     <br />
  //     <br />
  //     Voor ZZP-ers regelen wij bemiddeling bij nieuwe (langdurige) projecten,
  //     bieden opleidingen middels een gereserveerd opleidingspotje via gelieerde
  //     opleidingscentra en onze eigen mensen, zorgen voor administratieve
  //     ondersteuning middels een eigen administratiekantoor aangaande de
  //     facturering en gehele financiële administratie inclusief aangiftes en
  //     tevens verhuren wij materieel.
  //   </>
  // );

  return (
    <div>
      <Helmet>
        <title>DD-Group</title>
        <meta
          name="description"
          content="Den Doelder Recruitment biedt topkwaliteit personeelsdiensten, volgens belangrijke branchecertificeringen en normen. We maken deel uit van verschillende brancheorganisaties en volgen de overheidseisen voor tijdelijk werk. Onze certificeringen omvatten SNA, VCU, KIWA en ABU, die ervoor zorgen dat we voldoen aan hoge normen voor veiligheid en betrouwbaarheid. We verstrekken ook WKA-verklaringen en beheren G-rekeningen voor een duidelijke loonbelastingadministratie. Neem contact met ons op via info@DD-Group.nl voor betrouwbare personeelsoplossingen."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <Welcome
          videoSource={videoSource}
          heading={welcomeHeading}
          text={welcomeText}
        />
        <section>
          <ImageText1
            imageUrl={imageUrl}
            heading={imageTextHeading}
            text={imageTextText}
          />
          {/* <ImageText2
            imageUrl={imageUrl2}
            heading={imageTextHeading2}
            text={imageTextText2}
          /> */}

          {/* <VideoText /> */}
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default Home;
